// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { LoginDto } from 'types/ApiTypes'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

// Define a service using a base URL and expected endpoints
export const UserInfoAPI = createApi({
  reducerPath: 'userInfoAPI',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  // baseQuery: baseQueryWithErrorHandler,
  endpoints: builder => ({
    postSignIn: builder.mutation<LoginDto, LoginDto>({
      query: body => ({ url: `api/Users/login`, method: 'POST', body }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { usePostSignInMutation } = UserInfoAPI
